var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: "1vw",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L14.1667 14.1667M15.8333 9.16667C15.8333 10.9348 15.131 12.6305 13.8807 13.8807C12.6305 15.131 10.9348 15.8333 9.16667 15.8333C7.39856 15.8333 5.70286 15.131 4.45262 13.8807C3.20238 12.6305 2.5 10.9348 2.5 9.16667C2.5 7.39856 3.20238 5.70286 4.45262 4.45262C5.70286 3.20238 7.39856 2.5 9.16667 2.5C10.9348 2.5 12.6305 3.20238 13.8807 4.45262C15.131 5.70286 15.8333 7.39856 15.8333 9.16667Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSearchIcon);
export default __webpack_public_path__ + "static/media/dark_search_icon.68e55c06f1a4e8c0686fca608ee8302b.svg";
export { ForwardRef as ReactComponent };